"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const KeyCode = tslib_1.__importStar(require("../../util/KeyboardEventCodes"));
const DropdownUtil_1 = tslib_1.__importDefault(require("../../dropdown/DropdownUtil"));
/**
 * @deprecated Use {@link UngroupedDropdownWidget} or {@link GroupedDropdownWidget} instead.
 */
class AbstractDropdown extends fmko_ts_common_1.Widget {
    constructor(model) {
        super();
        this.model = model;
        this.options = [];
        this.optionToIndexMap = new Map();
        this.currentLiSelected = -1;
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.scrollListener = () => {
            this.renderTopOrBottom();
        };
        this.element = document.createElement("div");
        this.element.classList.add("dropdown-container");
        const ulId = fmko_ts_common_1.GlobalCounter.next();
        const buttonId = fmko_ts_common_1.GlobalCounter.next();
        this.dropdownButton = document.createElement("button");
        this.dropdownButton.id = buttonId;
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.HAS_POPUP, fmko_ts_common_1.ARIARole.LIST_BOX);
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, ulId);
        this.dropdownButton.textContent = "Der er ingen valgmuligheder";
        this.dropdown = document.createElement("ul");
        this.dropdown.id = ulId;
        // We need to use mouseup and keyup for the button,
        // because for click enter is fired on keydown and keyup, while space is only fired on key up
        // and we the problem with keydown is that the dropdown gets focus, and when keyup is fired, the dropdown closes.
        this.dropdownButton.addEventListener("mouseup", () => {
            this.handleDropdownButtonClick();
        });
        this.dropdownButton.addEventListener("keyup", event => {
            if (KeyCode.isEnter(event) || KeyCode.isSpace(event) || KeyCode.isArrowDown(event) || KeyCode.isArrowUp(event)) {
                this.handleDropdownButtonClick();
                if (KeyCode.isArrowDown(event) || KeyCode.isArrowUp(event)) {
                    this.handleDropDownKeyNavigation(event);
                }
            }
        });
        this.dropdown.addEventListener("mouseenter", () => {
            this.dropdown.focus();
        });
        this.dropdown.addEventListener("keydown", event => {
            this.handleDropDownKeyNavigation(event);
        }, true);
        this.dropdown.addEventListener("keyup", event => {
            this.handleDropdownOnKeyUp(event);
        }, true);
        this.dropdown.addEventListener("blur", () => {
            this.hideSuggestions();
            this.dropdownBlurDate = new Date();
        });
        fmko_ts_common_1.WCAG.addButtonEvent({
            ariaRole: fmko_ts_common_1.ARIARole.LIST_BOX,
            callback: () => {
                const currentlyHighlightedIndex = this.optionToIndexMap.get(this.currentLiHighlighted);
                if (typeof currentlyHighlightedIndex == "number") {
                    this.setValue(this.options[currentlyHighlightedIndex], true);
                    this.hideSuggestions();
                }
            },
            element: this.dropdown,
            tabIndex: "-1"
        });
        this.element.appendChild(this.dropdownButton);
        this.element.appendChild(this.dropdown);
    }
    getSelect() {
        return this.element;
    }
    getOptions() {
        return this.options;
    }
    getValue() {
        const selectedIndex = this.currentLiSelected;
        if (selectedIndex >= 0 && selectedIndex < this.options.length) {
            return this.options[selectedIndex];
        }
        else {
            return null;
        }
    }
    setValue(value, fireEvents = false) {
        const oldValue = this.getValue();
        const optionIndex = this.options?.findIndex(option => value === option
            || (value && option)
                && this.model.isEqual(value, option)) ?? -1;
        if (optionIndex > -1) {
            this.select(optionIndex);
        }
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldValue, value);
        }
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    setOptions(options) {
        const selected = this.getValue();
        this.options = [...options];
        this.optionToIndexMap.clear();
        while (this.dropdown.firstChild) {
            this.dropdown.removeChild(this.dropdown.firstChild);
        }
        this.currentLiHighlighted = undefined;
        this.dropdownButton.textContent = "Der er ingen valgmuligheder";
        for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            const listItem = document.createElement("li");
            const itemId = fmko_ts_common_1.GlobalCounter.next();
            listItem.setAttribute("role", fmko_ts_common_1.ARIARole.OPTION);
            listItem.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
            listItem.id = itemId;
            listItem.textContent = this.model.formatItem(option);
            listItem.addEventListener("mouseover", () => {
                // a scroll in the ul triggers a mouseover
                if (DropdownUtil_1.default.dateHasPassedThreshold(this.lastScrollDate)) {
                    this.highlight(listItem);
                }
            });
            if (i === 0) {
                this.currentLiHighlighted = listItem;
                this.dropdownButton.textContent = this.model.getTextForNoOptionSelected();
            }
            this.optionToIndexMap.set(listItem, i);
            this.dropdown.appendChild(listItem);
        }
        if (selected) {
            this.setValue(selected);
            // Either the function doesn't exist or the new function is used and should be checked
        }
        else if (options.length === 1 && (!this.model.selectIfSingleOption || this.model.selectIfSingleOption())) {
            this.setValue(options[0]);
        }
        else if (!this.model.getTextForNoOptionSelected()) {
            this.setValue(options[0]);
        }
    }
    /* from Focusable interface. */
    setFocus(focused) {
        if (focused) {
            this.dropdownButton.focus();
        }
        else {
            this.dropdownButton.blur();
        }
    }
    setEnabled(enabled) {
        (0, fmko_ts_common_1.setEnabled)(this.dropdownButton, enabled);
    }
    highlight(newLi) {
        if (this.currentLiHighlighted) {
            this.dropdown.removeAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS);
            this.currentLiHighlighted.classList.remove("dropdown-li-highlighted");
            this.currentLiHighlighted = undefined;
        }
        this.currentLiHighlighted = newLi;
        if (newLi) {
            this.dropdown.setAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS, newLi.id);
            newLi.classList.add("dropdown-li-highlighted");
        }
    }
    showSuggestions() {
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "true");
        this.dropdown.setAttribute("tabindex", "0");
        this.renderTopOrBottom();
        document.body.addEventListener("scroll", this.scrollListener, true);
        this.dropdown.focus();
    }
    hideSuggestions() {
        this.dropdown.setAttribute("tabindex", "-1");
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        this.dropdown.removeAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS);
        document.body.removeEventListener("scroll", this.scrollListener, true);
        this.dropdownButton.focus();
    }
    select(newIndex) {
        if (this.currentLiSelected > -1) {
            const currentLi = this.dropdown.children[this.currentLiSelected];
            currentLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
        }
        this.currentLiSelected = newIndex;
        const newLi = this.dropdown.children[this.currentLiSelected];
        this.dropdownButton.textContent = newLi.textContent;
        this.dropdownButton.classList.add("dropdown-is-selected");
        newLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "true");
    }
    handleDropDownKeyNavigation(event) {
        let element = undefined;
        if (!this.options.length) {
            return;
        }
        if (!KeyCode.hasModifierKey(event) && this.currentLiHighlighted) {
            event.preventDefault();
            if (KeyCode.isArrowDown(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlighted, "next");
            }
            else if (KeyCode.isArrowUp(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlighted, "previous");
            }
            else if (KeyCode.isHome(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[0];
            }
            else if (KeyCode.isEnd(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.options.length - 1];
            }
            if (element) {
                this.highlight(element);
                this.scrollIntoView(element);
            }
        }
    }
    handleDropdownButtonClick() {
        // Don't open listbox again if the event was closed by dropdown blur
        if (!DropdownUtil_1.default.dateHasPassedThreshold(this.dropdownBlurDate)) {
            return;
        }
        const nextExpandState = !(this.dropdownButton.getAttribute(fmko_ts_common_1.ARIA.EXPANDED) === "true");
        if (this.options.length && nextExpandState) {
            // If there are options and the index hasn't been moved, then move it to 0
            const toHighlight = this.currentLiSelected !== -1
                ? this.optionToIndexMap[this.currentLiSelected]
                : this.currentLiHighlighted;
            this.highlight(toHighlight);
            this.showSuggestions();
            this.scrollIntoView(toHighlight);
        }
        else {
            this.hideSuggestions();
        }
    }
    handleDropdownOnKeyUp(event) {
        if (!KeyCode.hasModifierKey(event)) {
            if (KeyCode.isEscape(event) || KeyCode.isTab(event)) {
                this.hideSuggestions();
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
    renderTopOrBottom() {
        const buttonBottom = this.dropdownButton.getBoundingClientRect().bottom;
        const dropdownHeight = this.dropdown.getBoundingClientRect().height;
        const windowTotalHeight = window.innerHeight;
        const dropDownOutsideOfView = buttonBottom + dropdownHeight > windowTotalHeight;
        this.dropdown.classList.toggle("render-dropdown-on-top", dropDownOutsideOfView);
    }
    scrollIntoView(element) {
        if (element) {
            const index = this.optionToIndexMap.get(element);
            if (typeof index === "number") {
                const elementHeight = element.getBoundingClientRect().height;
                const scrollTo = elementHeight * index;
                const listTop = this.dropdown.scrollTop;
                const listHeight = this.dropdown.clientHeight;
                const listBottom = listTop + listHeight;
                if (scrollTo < listTop) {
                    this.dropdown.scrollTop = scrollTo;
                }
                if (scrollTo >= listBottom) {
                    this.dropdown.scrollTop = (scrollTo + elementHeight) - listHeight;
                }
                this.lastScrollDate = new Date();
            }
        }
    }
    findEnabledAdjacentSibling(element, direction, originalElement) {
        if (element === originalElement) {
            return originalElement; // We have iterated through the entire list of children
        }
        const relevantOriginalElement = originalElement || element;
        const adjacentIndex = direction === "previous" ? -1 : 1;
        const optionIndex = this.optionToIndexMap.get(element);
        const nextIndex = optionIndex + adjacentIndex;
        let adjacentElement;
        if (nextIndex > -1) {
            // Either the element is next in the array, or we are at this.optionElements.length, thus we have to reset to 0
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[nextIndex % this.options.length];
        }
        else {
            // If we are -1, then we need to go to the end again
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.options.length - 1];
        }
        return this.getElementOrFindAdjacent(direction, adjacentElement, relevantOriginalElement);
    }
    getElementOrFindAdjacent(direction, element, originalElement) {
        if (element) {
            if (!element.hasAttribute("disabled")) {
                return element;
            }
            else {
                // If it's the first recursion then add element as original element
                this.findEnabledAdjacentSibling(element, direction, originalElement);
            }
        }
    }
}
exports.default = AbstractDropdown;
//# sourceMappingURL=AbstractDropdown.js.map